"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InformField = exports.InformEl = void 0;

var _react = _interopRequireDefault(require("react"));

var _excluded = ["children", "initialValues", "onInformelReady"],
    _excluded2 = ["children", "className"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var BaseInformEl = generateEl('inform-el', 'BaseInformEl', ['informel-ready', 'inform-input', 'inform-change', 'inform-submit', 'request-start', 'request-end', 'request-success', 'request-error'], ['validationHandler', 'zodSchema']);
var InformField = generateEl('inform-field', 'InformField'); // InformEl with initialValues

exports.InformField = InformField;

var InformEl = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var children = _ref.children,
      initialValues = _ref.initialValues,
      onInformelReady = _ref.onInformelReady,
      rest = _objectWithoutProperties(_ref, _excluded);

  var initialValuesSet = _react["default"].useRef(false);

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      informelReady = _React$useState2[0],
      setInformelReady = _React$useState2[1];

  var innerRef = _react["default"].useRef(null);

  var combinedRef = useCombinedRefs(ref, innerRef);

  var handleInformelReady = function handleInformelReady(e) {
    setInformelReady(true);

    if (onInformelReady) {
      onInformelReady(e);
    }
  };

  useLayoutEffectSSRSafe(function () {
    if (!initialValuesSet.current && initialValues && informelReady) {
      combinedRef.current.reset(initialValues);
      initialValuesSet.current = true;
    }
  }, [initialValues, informelReady]);
  return /*#__PURE__*/_react["default"].createElement(BaseInformEl, _extends({}, rest, {
    ref: combinedRef,
    onInformelReady: handleInformelReady
  }), children);
});

exports.InformEl = InformEl;
InformEl.displayName = 'InformEl';

function generateEl(el, displayName) {
  var events = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var properties = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  // Web components wrapper
  var Inner = /*#__PURE__*/_react["default"].forwardRef(function Wrapper(_ref2, ref) {
    var _ref2$children = _ref2.children,
        children = _ref2$children === void 0 ? null : _ref2$children,
        _ref2$className = _ref2.className,
        className = _ref2$className === void 0 ? '' : _ref2$className,
        rest = _objectWithoutProperties(_ref2, _excluded2);

    var Tag = el; // We use forwardRef but we also need to use that ref internally: https://itnext.io/reusing-the-ref-from-forwardref-with-react-hooks-4ce9df693dd

    var combinedRef = useCombinedRefs(ref); // Forwards the event to corresponding `onCamelCaseEventName` prop

    var handleEvent = useEvent(function (event) {
      var reactEventName = toCamelCase("on-".concat(event));

      if (rest[reactEventName]) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        rest[reactEventName].apply(rest, args);
      }
    });
    useLayoutEffectSSRSafe(function () {
      var eventHandlersByName = events.reduce(function (acc, event) {
        return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, event, function () {
          for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
          }

          return handleEvent.apply(void 0, [event].concat(args));
        }));
      }, {}); // Add an event listener for each specified event

      events.forEach(function (event) {
        var _combinedRef$current;

        combinedRef === null || combinedRef === void 0 ? void 0 : (_combinedRef$current = combinedRef.current) === null || _combinedRef$current === void 0 ? void 0 : _combinedRef$current.addEventListener(event, eventHandlersByName[event]);
      });
      return function () {
        // Remove the event listener for each specified event
        events.forEach(function (event) {
          var _combinedRef$current2;

          combinedRef === null || combinedRef === void 0 ? void 0 : (_combinedRef$current2 = combinedRef.current) === null || _combinedRef$current2 === void 0 ? void 0 : _combinedRef$current2.removeEventListener(event, eventHandlersByName[event]);
        });
      };
    }, []);
    useLayoutEffectSSRSafe(function () {
      // Forwarding functions as props
      Object.keys(rest).forEach(function (propName) {
        // If a prop is a function and is not in the list of events, we forward it as a prop
        if (typeof rest[propName] === 'function' || properties.includes(propName)) {
          var eventName = toKebabCase(propName.replace(/^(on)/, ''));

          if (!events.includes(eventName)) {
            combinedRef.current[propName] = rest[propName];
          }
        }
      });
    }); // Remove undefined or null attributes

    var restDefined = Object.keys(rest).reduce(function (result, key) {
      if (rest[key] !== null && rest[key] !== undefined && typeof rest[key] !== 'function' && (typeof rest[key] !== 'boolean' || rest[key])) {
        // Support both the camelCase and kebab-case version
        result[toKebabCase(key)] = rest[key];
        result[key] = rest[key];
      }

      return result;
    }, {});
    return (
      /*#__PURE__*/
      // For webcomponents, we need to use `class` instead of `className`
      _react["default"].createElement(Tag, _extends({
        ref: combinedRef,
        "class": className
      }, restDefined), children)
    );
  });

  Inner.displayName = displayName || el;
  return Inner;
}

function toKebabCase(str) {
  return str.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}

function toCamelCase(str) {
  return str.replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
} // https://itnext.io/reusing-the-ref-from-forwardref-with-react-hooks-4ce9df693dd


function useCombinedRefs() {
  for (var _len3 = arguments.length, refs = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    refs[_key3] = arguments[_key3];
  }

  var targetRef = _react["default"].useRef();

  _react["default"].useEffect(function () {
    refs.forEach(function (ref) {
      if (!ref) return;

      if (typeof ref === 'function') {
        ref(targetRef.current);
      } else {
        ref.current = targetRef.current;
      }
    });
  }, refs);

  return targetRef;
}

;

var useEvent = function useEvent(handler) {
  var handlerRef = _react["default"].useRef(null);

  useLayoutEffectSSRSafe(function () {
    handlerRef.current = handler;
  });
  return _react["default"].useCallback(function () {
    var fn = handlerRef.current;
    return fn.apply(void 0, arguments);
  }, []);
}; // useLayoutEffect does't play well with NextJS SSR: https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a


var useLayoutEffectSSRSafe = typeof window !== 'undefined' ? _react["default"].useLayoutEffect : _react["default"].useEffect;